import { createBrowserHistory } from 'history'

const history = createBrowserHistory()

const originalPush = history.push.bind(history)

const extendedHistory = Object.assign(history, {
  from: null,
  current: null,
  currentAction: 'REPLACE',
  push(to, state) {
    addState(state)
    return originalPush(to, state)
  },
  getTransition() {
    return this.transition
  }
})

function addState(state) {
  if (extendedHistory.current) {
    extendedHistory.from = extendedHistory.current
  }
  extendedHistory.current = state
  extendedHistory.currentAction = 'PUSH'
}

history.listen(update => {
  if (update.action === 'REPLACE' && extendedHistory.current === null) {
    extendedHistory.current = update.location.state
  }

  if (update.action !== 'POP') return

  // Get current state after pop
  const state = update.location.state

  extendedHistory.from = extendedHistory.current
  extendedHistory.current = state
  extendedHistory.currentAction = 'POP'
})

export default extendedHistory
